import { gql } from "@apollo/client";

export const UPDATE_JUSTIFICACION_CONDICIONAL = gql`
    mutation UpdateJustificacion(
        $idJustificacion: Int! 
        $area: String!
        $estado: String!
        $idJustificado: Int!
        $observacion: String!
    ){
    updateJustificacion(input:{
            idJustificacion: $idJustificacion 
            area: $area
            estado: $estado
            idJustificado: $idJustificado
            observacion: $observacion
        })
}
`;